module.exports = __webpack_public_path__ + "img/FGr_Fachgruppe.71fe47ed.svg";